import {
  ACCESS_TOKEN_EXPIRES_AT_KEY,
  ID_TOKEN_KEY,
  REFRESH_TOKEN_KEY,
  TOKEN_KEY,
  TOKEN_TYPE_KEY,
  USER_KEY,
} from './types';
import type { StorageConfig } from './types/auth-config';

export interface ResolvedStorageKeys {
  tokenKey: string;
  userKey: string;
  refreshTokenKey: string;
  idTokenKey: string;
  tokenTypeKey: string;
  tokenExpiresAtKey: string;
  storageType: 'localStorage' | 'sessionStorage' | 'memory';
}

export const DEFAULT_STORAGE_KEYS: ResolvedStorageKeys = {
  tokenKey: TOKEN_KEY,
  userKey: USER_KEY,
  refreshTokenKey: REFRESH_TOKEN_KEY,
  idTokenKey: ID_TOKEN_KEY,
  tokenTypeKey: TOKEN_TYPE_KEY,
  tokenExpiresAtKey: ACCESS_TOKEN_EXPIRES_AT_KEY,
  storageType: 'localStorage',
};

export const resolveStorageKeys = (
  storage?: StorageConfig | Partial<ResolvedStorageKeys>,
): ResolvedStorageKeys => ({
  ...DEFAULT_STORAGE_KEYS,
  ...storage,
});
